// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LoadingBar from 'react-redux-loading-bar'
import Cookies from 'js-cookie'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import PlusCircle from 'components/svg/plus-circle.svg'

class RegisterLogin extends React.Component {
	render() {
		return (
			<div className="register-login">
				<div className="-inner">
					<div className="-register">
						<Link className="button is-large" to="/register"><PlusCircle /><span>Register a new claim</span></Link>
					</div>

					<div className="-login">
						<a className="button is-large" href={ `${siteData.site_url}wp-login.php?redirect_to=${siteData.site_url}` }>Log in for existing claim</a>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( RegisterLogin )
